import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { UserDetails } from 'src/app/core/models/user-details.model';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { HomeService } from 'src/app/home/home.service';
import { SessionService } from '../session-service/session.service';
import { ImpersonationService } from '../impersonation/impersonation.service';

@Component({
  selector: 'client-manager-view',
  templateUrl: './client-manager-view.component.html',
  styleUrls: ['./client-manager-view.component.scss']
})

export class ClientManagerViewComponent implements OnInit, OnDestroy {
  isLoginAsClientManager = false;
  subscriptions: Subscription[] = [];
  userDetails: UserDetails;

  constructor(
    private _userDataService: UserDataService,
    private _homeService: HomeService,
    private _sessionService: SessionService,
    private _router: Router,
    private impersonationService: ImpersonationService,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
        this._userDataService.userDetails$.subscribe(userdetails => {
            this.userDetails = userdetails;
        })
    );


    this.subscriptions.push(
        this.impersonationService.clientManagerModeActive$.subscribe((isActive) => {
            this.isLoginAsClientManager = isActive;
        })
    );

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(element => {
      if (!element.closed) {
        element.unsubscribe();
      }
    });
  }

  exitClientView() {
    this.impersonationService.deactivateClientManagerView();
  }
}
